<template>
  <CDropdown variant="nav-item">
    <CDropdownToggle placement="bottom-end" class="py-0" :caret="false">
      <span class="nameSet"> {{ name }}
      <span v-if="isDev" class="dev">(測試環境)</span>
      </span>
      <CAvatar :src="circleUrl" size="md" />
    </CDropdownToggle>
    <CDropdownMenu class="pt-0">
      <CDropdownItem v-on:click="logout">
        <CIcon icon="cil-lock-locked" /> 登出
      </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
</template>

<script>
import firebase from 'firebase/compat/app';
import "firebase/compat/auth";

export default {
  name: 'AppHeaderDropdownAccnt',
  data() {
    return {
      itemsCount: 42,
      circleUrl:
        'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      name: '',
      isDev: process.env.NODE_ENV != 'production'
    }
  },
  created() {
    var user = firebase.auth().currentUser
    if (user) {
      this.name = user.displayName
    }

  },
  methods: {
    logout() {
      firebase.auth().signOut().then(() => {
        this.$message.success('成功登出!')
        this.$router.replace({ name: 'Login' })
      })
    },
  },
}
</script>

<style scoped>
.nameSet {
  margin-right: 10px;
  font-size: 18px;
  font-weight: 400;
  color: #909399;
}

.dev {
  color: #f08e4c;
}
</style>
